import { render } from "./MaxValue.vue?vue&type=template&id=4fd85400"
import script from "./MaxValue.vue?vue&type=script&lang=ts"
export * from "./MaxValue.vue?vue&type=script&lang=ts"

import "./MaxValue.vue?vue&type=style&index=0&id=4fd85400&lang=css"
script.render = render

export default script